import Icon from './Icon'
import OverlayFullScreen from './OverlayFullScreen'

const OverlaySurveyClosed = ({
  onClose,
  subtitle,
  title,
}: {
  onClose?(): void
  subtitle: string
  title: string
}) => {
  return (
    <OverlayFullScreen onClose={onClose}>
      <div className="flex flex-col items-center space-y-6 text-center">
        <div className="w-36">
          <Icon id="survey-closed" />
        </div>
        <p className="text-4xl font-semibold">{title}</p>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </OverlayFullScreen>
  )
}

export default OverlaySurveyClosed
